import './index.scss';
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import { addFilter } from '@wordpress/hooks';

import { 
	InspectorControls, 
	PanelColorSettings 
} from '@wordpress/block-editor';
import { 
	PanelBody, 
	TextControl 
} from '@wordpress/components';


const allowedBlocks = ['aver/aver-icon-block'];

const addAttributes = ( settings, name ) => {		
	if ( !allowedBlocks.includes( name ) ) return settings;

	if (typeof settings.attributes !== 'undefined') {
		settings.attributes = {
			...settings.attributes,
			tooltip: {
				type: 'object',
				default: {
					text: '',
					color: '#fff',
					bg: '#111',
				},
			},
		}
	}
	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {

	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;
			
		const { name, attributes, setAttributes, isSelected } = props;
		const { tooltip } = attributes;


		const updateObject = (obj, key, newValue ) => {
  		return {
    		...obj,
    		[key]: newValue
  		};
		};		

		return (
			<>
				<BlockEdit {...props} />
				
				{isSelected && (
					<InspectorControls>

						<PanelBody title={__('Tooltip Settings (Pro)', 'aver')} initialOpen={false}>
							<TextControl
								label={__('Tooltip Text', 'aver')}
								value={tooltip.text}
								onChange={(newval) =>
									setAttributes({ tooltip: {tooltip, text: newval } })
								}
							/>
							{tooltip.text && (
								<PanelColorSettings
									title={__('Tooltip Color Settings', 'aver')}
									icon="admin-appearance"
									initialOpen
									disableCustomColors={false}
									enableAlpha={true}
									colorSettings={[
										{
											value: tooltip.color,
											onChange: (newval) =>
												setAttributes({ tooltip: { tooltip, color: newval} }),
											label: __('Tooltip Color', 'aver'),
										},
										{
											value: tooltip.bg,
											onChange: (newval) =>
												setAttributes({ tooltip: { tooltip, bg: newval} }),
											label: __('Tooltip Background Color', 'aver'),
										},
									]}
								/>
							)}
						</PanelBody>

					</InspectorControls>
				)}
			</>
		);
}



const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {
			
			if ( ! allowedBlocks.includes( props.name ) ) {
				return (
					<BlockListBlock { ...props } />
				);
			}

			const { attributes, wrapperProps, className } = props;
			const { tooltip } = attributes;

			if ( tooltip['text'] === '') {
				return (
					<BlockListBlock { ...props } />
				);
			}     
		

			const cssstyle = { 
				...wrapperProps?.style,
				...( tooltip['color'] && tooltip['text'] && { '--pColor': `${tooltip['color']}` }),
				...( tooltip['bg'] && tooltip['text'] && { '--pBgColor': `${tooltip['bg']}` }),
			} 				

			const classes = classnames(
				className, ``, 
				{ 
					[ `custom-tooltip-trigger` ] : tooltip['text'],	                               
				}
			);		

			return <BlockListBlock 
				{ ...props }        
				wrapperProps={{
					...wrapperProps,
					style: cssstyle,
					'data-tooltip': tooltip['text']
				}}			
				className={ classes } 			
				
			/>
				
}




addFilter(
	'blocks.registerBlockType',
	'aver/extend-aver-icon-block-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/extend-aver-icon-block-advanced-control',	
	addInspectorControl
);

addFilter(
		'editor.BlockListBlock',
		'aver/extend-aver-icon-block-editor-class',
		applyExtraClassEditor
);